/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { opportunitySchema } from './opportunity-schema';
import { topTaskSchema } from './top-task-schema';
import { ReputationActionTaken } from "../enums";

export const candidateReputationDetailSchema: z.AnyZodObject = z.object({
  actionNotes: z.string().nullish(),
  actionTaken: z.nativeEnum(ReputationActionTaken).nullish(),
  actionTakenAt: z.string().datetime().nullish(),
  actionTakenHistory: 
    z.object({
      actionTakenEvents: 
        z.array(
          z.object({
            actionNotes: z.string().nullish(),
            actionTaken: z.nativeEnum(ReputationActionTaken).nullish(),
            actionTakenAt: z.string().datetime().nullish(),
            takenByUserId: z.string().uuid().nullish(),
          })
        )
      .nullish(),
    })
  .nullish(),
  axiomClientRecommendScore: z.number().int().nullish(),
  axiomDidWellOn: z.string().nullish(),
  axiomImproveOn: z.string().nullish(),
  businessJudgementScore: z.number().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid(),
  clientRecommendScore: z.number().int().nullish(),
  communicationScore: z.number().nullish(),
  createdAt: z.string().datetime().nullish(),
  didWellOn: z.string().nullish(),
  historical: z.boolean(),
  id: z.string().uuid(),
  improveOn: z.string().nullish(),
  inTopTenPercent: z.boolean().nullish(),
  legalExpertiseScore: z.number().nullish(),
  matterId: z.string().nullish(),
  meetsExpectations: z.boolean().nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid(),
  respondentName: z.string().nullish(),
  responseDate: z.string().date().nullish(),
  responseId: z.string().nullish(),
  responsivenessScore: z.number().nullish(),
  retiredDidWellOnImproveOn: z.string().nullish(),
  topTask: z.lazy(() => topTaskSchema).nullish(),
  topTaskId: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidateReputationDetail = z.infer<typeof candidateReputationDetailSchema>;
